import React, {
    useState,
    useMemo,
    useEffect,
    useRef,
    useCallback,
} from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { industries as industriesApi } from '@fiverr-private/variations_display/src/api';
import { DEFAULT_LOCALE } from '../../../../../marketplace/constants';

export const useIndustriesContextValue = () => {
    const [industries, setIndustries] = useState([]);
    const [industrySuggestions, setIndustrySuggestions] = useState([]);
    const prevAutocompleteSource = useRef(null);

    const updateIndustrySuggestions = useCallback(
        async (term) => {
            if (!term) {
                return [];
            }
            if (prevAutocompleteSource?.current) {
                prevAutocompleteSource.current.cancel();
            }
            const [suggestionsPromise, source] = industriesApi.autocomplete(
                term,
                false
            );
            prevAutocompleteSource.current = source;

            try {
                const { industries: items, moreSuggestions } =
                    await suggestionsPromise;
                const suggestionsList = [
                    { items },
                    {
                        label: (
                            <I18n k="variations_display.marketplace_listing.brief.industry_picker.alt_title" />
                        ),
                        items: moreSuggestions,
                    },
                ];
                setIndustrySuggestions(suggestionsList);
            } catch {
                setIndustrySuggestions([]);
            }
        },
        [setIndustrySuggestions]
    );

    useEffect(() => {
        industriesApi
            .get(DEFAULT_LOCALE)
            .then(({ industries }) => setIndustries(industries))
            .catch(() => setIndustries([]));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return useMemo(
        () => ({
            getIndustryTitle: (value) =>
                industries.find((i) => i.slug === value)?.title,
            industrySuggestions,
            updateIndustrySuggestions,
        }),
        [industries, industrySuggestions, updateIndustrySuggestions]
    );
};
